import { Component, OnInit, Inject } from '@angular/core';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { HttpService } from 'src/app/core/http/http.service';
import { ITaskDayDetail } from '@shared/models/task.model';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-close-events',
  templateUrl: './close-events.component.html',
  styleUrls: ['./close-events.component.scss']
})
export class CloseEventsComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public dailyTask: ITaskDayDetail[] = [];
  constructor(
    private service: HttpService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA)
    public data: { type_event: 'daily' | 'close'; body?: any }
  ) {
    super();
  }

  ngOnInit() {
    switch (this.data.type_event) {
      case 'daily':
        this.getDailyTasks(this.datePipe.transform(Date.now(), 'MM/dd/yyyy'));
        break;

      case 'close':
        this.dailyTask = [
          {
            ...this.data.body
          }
        ];
        break;
    }
  }

  getDailyTasks(date) {
    const parseDate = new Date(date);
    const monthDate = String(parseDate.getMonth() + 1).padStart(2, '0');
    const yearDate = parseDate.getFullYear();
    const dayDate = String(parseDate.getDate()).padStart(2, '0');
    this.subs.add(
      this.service
        .get(
          'task/calendar/detail/list/' +
            yearDate +
            '-' +
            monthDate +
            '-' +
            dayDate,
          {}
        )
        .subscribe((tasks: ITaskDayDetail[]) => {
          this.dailyTask = tasks;
        })
    );
  }
}
